const typeEnum = {
  TECHNICIAN: 1, //機師
  MECH: 2, //機甲
  WEAPON: 3, //武器
  PACK: 4, //背包
  MODULE: 5, //模组
  COMPONENT: 6, //元件
};

const qulityEnum = {
  NORMAL: "normal", //普通
  NICE: "nice", //优秀
  GREAT: "great", //极佳
  BEST: "best", //绝佳
};

const typeData = [
  {
    pageType: "customPage",
    title: "資料",
    customComponent: "resourceCenter", //跳转的动态组件
    dataSource: "baikeList", //这边是个一个url，用于请求数据
    dataForm: function() {
      //为了获取动态参数，这边使用需要用apply调用
      let form = {
        tagId: "401",
      };
      return form;
    },
  },
  {
    pageType: "originListPage",
    type: typeEnum.TECHNICIAN, //物品類型key，用于跳转详情页判断
    selectOptions: [
      //筛选条件，title是筛选框需要默认显示的文本，data是选择项
      {
        title: "品質",
        attr: "quality",
        data: [
          { key: "SSR", name: "S" },
          { key: "SR", name: "A" },
          { key: "R", name: "B" },
        ],
      },
      {
        title: "職業",
        attr: "Profession",
        data: [
          { key: "Assault", name: "突擊手" },
          { key: "Striker", name: "格鬥家" },
          { key: "Gunner", name: "狙擊手" },
          { key: "Launcher", name: "戰術家" },
          { key: "Mechanic", name: "機械師" },
          { key: "Defender", name: "守護者" },
        ],
      },
    ],
    title: "機師", //横向tab栏标题
    dataSource: "pilot_data",
  },
  {
    pageType: "originListPage",
    type: typeEnum.MECH,
    selectOptions: [
      {
        title: "品質",
        attr: "quality",
        data: [
          { key: "SSR", name: "S" },
          { key: "SR", name: "A" },
          { key: "R", name: "B" },
        ],
      },
      {
        title: "類型",
        attr: "type",
        data: [
          { key: "Light", name: "輕" },
          { key: "Medium", name: "中" },
          { key: "Heavy", name: "重" },
        ],
      },
    ],
    title: "機甲",
    dataSource: "aircraft_data",
  },
  {
    pageType: "originListPage",
    type: typeEnum.WEAPON,
    selectOptions: [
      {
        title: "品質",
        attr: "quality",
        data: [
          { key: "SSSR", name: "SS" },
          { key: "UR", name: "S+" },
          { key: "SSR", name: "S" },
          { key: "SR", name: "A" },
          { key: "R", name: "B" },
        ],
      },
      {
        title: "類型",
        attr: "WeaponType2",
        data: [
          { key: "Knuckle", name: "拳套" },
          { key: "PileBunker", name: "打樁機" },
          { key: "Rod", name: "長柄" },
          { key: "Buckler", name: "手盾" },
          { key: "MachineGun", name: "機槍" },
          { key: "HeavyMachineGun", name: "重機槍" },
          { key: "ShotGun", name: "霰彈槍" },
          { key: "LightSniper", name: "輕型步槍" },
          { key: "HeavySniper", name: "狙擊步槍" },
          { key: "Shield", name: "大盾" },
          { key: "Rocket", name: "火箭" },
          { key: "Missile", name: "導彈" },
          { key: "RailGun", name: "電磁炮" },
          { key: "Flamethrower", name: "噴火器" },
        ],
      },
    ],
    title: "武器",
    dataSource: "weapon_data",
  },
  {
    pageType: "originListPage",
    type: typeEnum.PACK,
    selectOptions: [
      {
        title: "品質",
        attr: "quality",
        data: [
          { key: "UR", name: "S+" },
          { key: "SSR", name: "S" },
          { key: "SR", name: "A" },
          { key: "R", name: "B" },
        ],
      },
      {
        title: "類型",
        attr: "BackpackMainType",
        data: [
          { key: "PowerAdd", name: "出力" },
          { key: "EMP", name: "干擾" },
          { key: "Enhance", name: "強化" },
          { key: "Heal", name: "修理" },
          { key: "Radar", name: "雷達" },
          { key: "Invisible", name: "隱形" },
          { key: "Ammo", name: "彈藥" },
          { key: "MovePointAdd", name: "移動" },
          { key: "Flow", name: "飛行" },
          { key: "Interference", name: "誘導" },
        ],
      },
    ],
    title: "背包",
    dataSource: "backpack_data",
  },
  {
    type: typeEnum.MODULE,
    pageType: "originListPage",
    selectOptions: [
      {
        title: "品質",
        attr: "quality",
        data: [
          { key: "SSR", name: "S" },
          { key: "SR", name: "A" },
        ],
      },
    ],
    title: "模组",
    dataSource: "module_props",
  },
  {
    type: typeEnum.COMPONENT,
    pageType: "originListPage",
    selectOptions: [
      {
        title: "品質",
        attr: "quality",
        data: [
          { key: "SSR", name: "S" },
          { key: "SR", name: "A" },
          { key: "R", name: "B" },
        ],
      },
      {
        title: "類型",
        attr: "IconType",
        data: [
          { key: "Condition", name: "觸元件" },
          { key: "Function", name: "應元件" },
          { key: "Condition2", name: "觸元件W" },
          { key: "Function2", name: "應元件W" },
        ],
      },
      {
        title: "子類型",
        attr: "ModuleSubtype",
        data: [
          { key: "1", name: "命中相關" },
          { key: "2", name: "攻擊方式" },
          { key: "3", name: "受擊相關" },
          { key: "4", name: "耐久相關" },
          { key: "5", name: "AP相關" },
          { key: "6", name: "戰中效果" },
          { key: "7", name: "戰後效果" },
          { key: "8", name: "攻擊结果" },
          { key: "9", name: "距離相關" },
          { key: "10", name: "特殊效果" },
          { key: "11", name: "移動相關" },
        ],
      },
    ],
    title: "元件",
    dataSource: "component_props",
  },
];

export { typeData, typeEnum, qulityEnum };
